/**
 * DateValueSelector Component
 *
 * Provides date and datetime input fields for date/datetime field types
 *
 * @module FilterEditor/DateValueSelector
 */

import React from 'react';
import { Input } from '@loader/ui';

import type { ValueSelectorProps } from './types';

export const DateValueSelector: React.FC<ValueSelectorProps> = ({
  canEdit = true,
  filter,
  selectedField,
  debouncedOnUpdate,
}) => {
  const isDatetime = selectedField?.data_type === 'datetime';

  return (
    <Input
      type={isDatetime ? 'datetime-local' : 'date'}
      value={
        filter.value
          ? isDatetime
            ? String(filter.value).slice(0, 16)
            : String(filter.value).split('T')[0]
          : ''
      }
      onChange={(e) => {
        debouncedOnUpdate({
          ...filter,
          value: e.target.value,
          field_name: selectedField?.name || filter.field_name,
        });
      }}
      disabled={!filter.field_id || !canEdit}
      className="bg-background w-full"
    />
  );
};
